import { render, staticRenderFns } from "./AboutPaymentOrder.vue?vue&type=template&id=5ed34756&scoped=true&"
import script from "./AboutPaymentOrder.vue?vue&type=script&lang=js&"
export * from "./AboutPaymentOrder.vue?vue&type=script&lang=js&"
import style0 from "./AboutPaymentOrder.vue?vue&type=style&index=0&id=5ed34756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed34756",
  null
  
)

export default component.exports